import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table view for reversion reload.
 * @extends JetView
 */
export default class tableReversionReloadView extends JetView {
    /**
     * Configures the view layout and data structure.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const data = [
            // Sample data for the datatable
            {
                NroCheck: '01',
                Client: 'asa',
                DocClient: 'asasa',
                Date: 'asas',
                Origin: 'asas',
                ReferenceDocument: 'asas',
                Value: 'asas',
                Currency: 'asa',
            },
        ];
        return {
            view: 'datatable', // Datatable view
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'RechargeNumber',
                    header: _('Nro. Recarga'), // Localized header
                    width: 200,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'ClientNumber',
                    header: _('Nro. Cliente'),
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'CustomerName',
                    header: _('Nombre Cliente'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CreationDate',
                    header: _('Fecha Creación'),
                    width: 150,
                    sort: 'int',
                },
                { id: 'Value', header: _('Valor'), width: 150, sort: 'int' },
                {
                    id: 'Currency',
                    header: _('Moneda'),
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'rating',
                    header: _('Acción'),
                    width: 300,
                    template: function (obj) {
                        // Button template for actions
                        return "<div class='webix_el_button'><button class='webixtype_base'>Revertir Recarga</button></div>";
                    },
                },
            ],
            onClick: {
                // Event handler for button clicks
                webixtype_base: (id) => {},
            },
            footer: true, // Enable footer
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager configuration
            url: devConfig.geturlApi() + 'es/GetTableReversionReload', // API endpoint for data
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        this.on(this.app, 'reprintCheck:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for API
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user event with item ID
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Load data based on selected player
        });
    }
}

// FILE DOCUMENTED
